
// Global dependencies
import { useState, useCallback, useContext } from "react";
import  AuthContext from "../../store/auth/AuthContextProvider";
// Project dependencies
const BASE_URL = process.env.REACT_APP_BASE_URL;

const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { authState, globalLogOutDispatch } = useContext(AuthContext);

  const request = useCallback(
    async (
      endpoint: string,
      params: { [key: string]: any },
      handleSuccessResponse: (data: any) => void,
      handleErrorResponse?: (error: Error) => void
    ) => {
      setLoading(true);
      setError(null);

      try {
        const groupId = localStorage.getItem("groupId");
        if (groupId) {
          params.headers["gid"] = groupId;
        }
        if (authState.isLoggedIn) {
          params.headers["x-access-token"] = authState.authToken;
        }

        const response = await fetch(BASE_URL + endpoint, { ...params });
        if (!response.ok) {
          if(response.status===401){
            globalLogOutDispatch();

          }
          const data = await response.json(); 
          throw new Error(data.message);
        }
        const data = await response.json(); 

        handleSuccessResponse && (await handleSuccessResponse(data));
      } catch (error: any) {

        alert(error??'مشکلی در سیستم بوجود اومده لطفا کمی بعد امتحان کنید')
        if (handleErrorResponse) {
          handleErrorResponse(error);
        } else {
          setError(error);
        }
      }

      setLoading(false);
    },

    [authState.isLoggedIn, authState.authToken, globalLogOutDispatch]
  );

  return {
    loading: loading,
    error: error,
    request: request,
    setError: setError,
  };
};

export default useApi;